import { Button, Segmented, Spin } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import { useRequest } from 'ahooks';
// import { useSelector } from 'react-redux';
import FixMenu from '@/components/FixMenu/FixMenu';
import bannerTitle from '@/assets/home/banner-title.png';
import { getBank, getInsurance } from '@/services/common';
import { getStatistical, getGuarantee } from '@/services/home';
import getMoney from '@/utils/getMoney';
import icon2 from '@/assets/home/icon2.png';
import icon3 from '@/assets/home/icon3.png';
import icon4 from '@/assets/home/icon4.png';
import icon5 from '@/assets/home/icon5.png';
import qrcode from '@/assets/qrcode.jpg';
import publicity from '@/assets/publicityFile/publicity.png';
import zdxmBanner from '@/assets/home/zdxm.png';
import PublicityModal from './components/PublicityModal';
import RiskModal from './components/RiskModal';
import './index.less';

const list = [
  { title: '入驻金融机构', num: 'orgNum', icon: icon2 },
  { title: '金融产品', num: 'productNum', icon: icon3 },
  { title: '申请笔数', num: 'loanNum', icon: icon4 },
  { title: '融资金额', num: 'amountNum', icon: icon5 },
];

// 风险提示已查看标记：sessionStorage 的 key 与写入值
const RISK_NOTIFIED_KEY = 'riskNotified';
const RISK_NOTIFIED_VALUE = '1';

export default function Home() {
  const Navigate = useNavigate();
  // const { userType } = useSelector((state) => state);
  const [key, setKey] = useState('银行');
  const publicitModalRef = useRef(null);
  // 风险提示弹窗是否打开
  const [riskOpen, setRiskOpen] = useState(false);
  // 风险提示是否已查看：首次点击后隐藏悬浮按钮上的提示小圆点
  const [riskNotified, setRiskNotified] = useState(() => localStorage.getItem(RISK_NOTIFIED_KEY) === RISK_NOTIFIED_VALUE);

  const openRiskModal = () => {
    if (!riskNotified) {
      setRiskNotified(true);
      localStorage.setItem(RISK_NOTIFIED_KEY, RISK_NOTIFIED_VALUE);
    }
    setRiskOpen(true);
  };

  const { data: statistical = {}, run } = useRequest(
    getStatistical,
    {
      manual: true,
    },
  );
  const { data: bank = [], loading } = useRequest(getBank);
  const { data: insurance = [] } = useRequest(getInsurance);
  const { data: guarantee = {} } = useRequest(getGuarantee);

  useEffect(() => {
    const timer = setInterval(() => {
      const areaName = sessionStorage.getItem('areaName');
      if (areaName) {
        run(areaName);
        clearInterval(timer);
      }
    }, 1000);
  }, []);

  function handleChange(e) {
    setKey(e);
  }
  function handleTo(id) {
    if (key === '担保') {
      Navigate('/guarantee');
    } else {
      Navigate(`/home/mechanism?id=${id}&type=${key}`);
    }
  }

  function onJump() {
    Navigate('/specialOffer');
  }

  // eslint-disable-next-line no-nested-ternary
  const data = key === '银行' ? bank : key === '保险' ? insurance : [guarantee];
  return (
    <div className="home">
      <div className="home__banner">
        <img src={bannerTitle} alt="" className="home__banner-title" />
        <div className="home__banner-zdxm">
          <a href="https://apfp.agri.cn/#/home?code=510000" target="_blank" rel="noopener noreferrer">
            <img alt="农业农村重大项目综合融资服务平台" src={zdxmBanner} width={312} />
          </a>
        </div>
        <div className="home__banner-publicity" onClick={() => publicitModalRef.current?.open()}>
          <img alt="防范非法金融活动宣传" src={publicity} />
        </div>
        <div className="home__banner-special-offer">
          <div>“1+1+8”专属产品</div>
          <div className="home__banner-special-offer-text">助力农业企业获取便捷、高效的融资服务。</div>
          <Button className="home__banner-special-offer-btn" onClick={onJump} type="primary">点击进入专区</Button>
        </div>
        {/* { */}
        {/*  userType !== 2 && ( */}
        {/*    */}
        {/*  ) */}
        {/* } */}
        <div className="home__banner-code">
          <img src={qrcode} alt="" width={123} height={124} />
          <div>手机扫一扫，办理更便捷</div>
        </div>
      </div>
      <div className="home__statistics-box">
        <div className="home__statistics">
          {
              list.map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div className="home__statistics-li" key={index}>
                  <img src={item.icon} alt="" />
                  <div className="home__statistics-li-num">
                    {index === 3 ? getMoney(statistical?.[item.num])?.num : statistical?.[item.num]}
                    {index === 3 && (
                      <span className="home__unit">
                      { getMoney(statistical?.[item.num])?.unit }
                      </span>
                    )}
                  </div>
                  <div className="home__statistics-li-title">{item.title}</div>
                </div>
              ))
          }
        </div>
      </div>
      <div className="home__Co">
        <div className="home__Co-conw">
          <div className="home__Co-title">合作机构</div>
          <Segmented block defaultValue={key} options={['银行', '保险', '担保']} onChange={handleChange} />
          <Spin spinning={loading}>
            <div className="home__Co-carousel-row">
              {
                  data.map((e) => (
                    <div key={e.orgId} className="home__Co-carousel-img-box">
                      <img src={e.url} alt="" key={e.orgId} onClick={() => handleTo(e.orgId)} className="home__Co-img" />
                    </div>
                  ))
              }
            </div>
          </Spin>
        </div>
      </div>
      <PublicityModal ref={publicitModalRef} />
      <RiskModal open={riskOpen} onClose={() => setRiskOpen(false)} />
      <div className="home__risk-fab" role="button" tabIndex={0} title="风险提示" onClick={openRiskModal}>
        {!riskNotified && <span className="home__risk-fab-badge" />}
        <span className="home__risk-fab-icon">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M12 2.6 4.8 5.4v6.1c0 4.6 3 8.7 7.2 9.9 4.2-1.2 7.2-5.3 7.2-9.9V5.4L12 2.6Z" fill="#fff" fillOpacity=".96" />
            <path d="M12 7.3v4.4" stroke="#F5760B" strokeWidth="2" strokeLinecap="round" />
            <circle cx="12" cy="14.7" r="1.25" fill="#F5760B" />
          </svg>
        </span>
        <span className="home__risk-fab-label">风险提示</span>
      </div>
      <FixMenu />
    </div>
  );
}
